import { VhcRecordLogService, VHCRecordPartInput } from 'api/generated';
import { ApiMutationOptions, useMutationWithNotifications } from 'api/utils/useMutationWithNotifications';

export type UpdateCheckPartsInput = {
  logId: number;
  itemId: number;
  partId: number;
  requestBody?: VHCRecordPartInput;
};

export const useUpdateCheckPartsMutation = (
  options?: ApiMutationOptions<typeof VhcRecordLogService.putVhcRecordsItemsChecksParts, UpdateCheckPartsInput>
) =>
  useMutationWithNotifications(
    ({ logId, itemId, partId, requestBody }: UpdateCheckPartsInput) =>
      VhcRecordLogService.putVhcRecordsItemsChecksParts(logId, itemId, partId, requestBody),
    options
  );
